import React from "react";
import { Button } from "react-bootstrap";
import posImg from "../../../Images/pos-onboarding.png";
import tLogoImg from "../../../Images/T-business-logo.png";

const InitialStep = ({ nextPage }) => {
  return (
    <div>
      <div className="text-center">
        <img src={tLogoImg} alt="T Business" />
      </div>
      <br></br>
      <h1 className="my-4 text-center">
        Molimo vas da upišete poslovne podatke za aktivaciju usluge Premium
        fiskalna blagajna
      </h1>
      <div className="row">
        <div className="col-lg-7 pr-5 pl-5">
          <h3>
            Popunjavanje upitnika traje desetak minuta. Preporučamo Vam da
            pripremite interni akt, u njemu ćete naći dio podataka koje je
            potrebno upisati.
          </h3>
          <p className="my-4">
            Za sva dodatna pitanja vezano za popunjavanje upitnika kontaktirajte
            nas na{" "}
            <a href="mailto: korisnik.pfb@t.ht.hr">korisnik.pfb@t.ht.hr</a>.
            ili na broj 01 3651212 od ponedjeljka do petka u periodu od 8:00 do
            16:00 sati
          </p>
          <p>Polja označena zvjezdicom su obavezna.</p>
        </div>
        <div className="col-lg-5 pl-5 pr-5">
          <img src={posImg} alt="POS uređaj" />
        </div>
        <div className="col-lg-12 text-right">
          <Button className="mt-4" onClick={() => nextPage({})}>
            Sljedeći korak
          </Button>
        </div>
      </div>
    </div>
  );
};

export default InitialStep;
